/*
 * @Description:
 * @Author: lijinpeng
 * @Date: 2024-05-08 10:08:48
 * @LastEditTime: 2024-05-13 18:29:56
 * @LastEditors: lijinpeng
 */
/* eslint-disable */
// import Vue from 'vue'
import { getCertifyInfo } from '@/api/eSign';
import { report, getCompanys, accountInfo, getOptMarkStatus } from '@/api/javaApi';
import store from '@/store/index';
import { companyLogin,unifiedLogin } from '@/api/login';
import { getAgentSMSValidate } from '@/api/agent';
import { getCookie , getSubdomain} from '@/assets/cookie';
import { Message } from 'element-ui';
import Cookies from 'js-cookie';
const actions = {
  getList: async () => {
    let ShippersUserInfo = getCookie('ShippersUserInfo');
    try {
        ShippersUserInfo = JSON.parse(decodeURIComponent(ShippersUserInfo));
    } catch (error) {
        console.log("解析错误:", error,ShippersUserInfo.accessToken);
    }
    console.log(111,ShippersUserInfo,ShippersUserInfo.from);
    if(ShippersUserInfo && ShippersUserInfo.from && ShippersUserInfo.from === 'shippers') {
      console.log('统一端登录')
      let res1 = await unifiedLogin();
      if (res1.code === 2002 || res1.code === 2003) {
        Message({
          message: '登录失效，请重新登录~',
          type: 'warning'
        });
        setTimeout(()=>{
          if (getCookie('ShippersUserInfo')) {
            const subdomain = getSubdomain(window.location.hostname);
            Cookies.remove('ShippersUserInfo', { domain: subdomain});
            Cookies.remove('satoken', { domain: subdomain });
            Cookies.remove('unified-token', { domain: subdomain });
            Cookies.remove('oss-token', { domain: subdomain });
          }
          window.location.href = window.location.origin.replace(window.location.host.split('.')[0],'cloud') + '/login'
        },3000)
      }
    }
   
    let res = await companyLogin();
    if (res.code === 200) {
      res.data.password = 1;
      store.commit('upheadUser', res.data.user);
      store.commit('updateUserName', res.data.user.name);
      store.commit('updateCorporationInfo', res.data.corporation);
      window.localStorage.token = res.data.xToken;
      window.localStorage.userInfo = JSON.stringify(res.data.user);
      window.localStorage.corporationInfo = JSON.stringify(res.data.corporation);
    }
    // else if (res.code === 403 || res.code === 403002) {
    //     window.location.href = window.location.origin.replace(window.location.host.split('.')[0], 'cloud') + '/login?redirect=' + window.location.href
    // }
    return res;
  },
  getOptMarkStatus: async () => {
    let { data } = await getOptMarkStatus({
      type: 'driver_ys_contract',
    });
    store.commit('isDialog', data);
  },
  getCertify: async () => {
    let { data } = await getCertifyInfo();
    try {
      if (data) {
        store.commit('upcreator', data.creator);
        store.commit('upadmin', data.admin);
        store.commit('upcorpCertityStatus', data.corpCertityStatus);
        store.commit('upuserCertityStatus', data.userCertityStatus);
      }
    } catch (err) {
      return err;
    }
  },
  getAll: async () => {
    let { data } = await report('ALL');
    try {
      if (data) {
        store.commit('upAxiosAll', data);
      }
    } catch (err) {
      return err;
    }
  },
  getCompany: async () => {
    let str = window.location.host.split('.')[0];
    try {
      let { data } = await getCompanys();
      if (data) {
        store.commit('updateCompanyList', data);
        data.filter(item => {
          if (item.subDomain === str) {
            store.commit('upcompanyName', item.name);
          }
        });
      }
    } catch (err) {
      return err;
    }
  },
  getInfo: async () => {
    let { data } = await accountInfo();
    try {
      if (data) {
        store.commit('upAccountInfo', data);
      }
    } catch (err) {
      return err;
    }
  },
  getAgentSMSValidate: async ({ commit, state }) => {
    try {
      const { data, code } = await getAgentSMSValidate({
        businessId: state.headUser.uid.businessID,
      });
      if (code === 200) {
        commit('updateAgentSMSValidateStatus', data.status);
      } else {
        commit('updateAgentSMSValidateStatus', '');
      }
    } catch (err) {
      console.error(err);
      return err;
    }
  },
};
export default actions;
